module.exports = __webpack_public_path__ + "static/img/jsldTu10@2x.2f40723a.png";